<template>
	<div class="comp-moment">
		<div class="comp-moment-wrap" v-if="viewType == 'basic'">
			<div class="comp-moment-tools" v-if="momentType == 1">
				<div class="comp-moment-t-title">【朋友圈】</div>
				<span title="刷新" class="comp-moment-t-reload" @click="refreshFansMoment()"></span>
				<!-- <span title="只看自己" class="comp-moment-t-eye"></span> -->
				<span title="关闭" class="comp-moment-t-close"></span>
			</div>
			<div class="comp-moment-box" :class="{'comp-moment-me-box': momentType == 2}">
				<div class="comp-moment-box-wrap" id="comp-moment-box-wrap" @scroll="momentScroll">
					<div class="comp-moment-remind" v-if="noticeList.length>0 && momentType == 2">
						<div class="comp-moment-remind-box" @click="noticeClick">
							<img :src="lastNoticeUser.wx_photo" alt="">
							<span class="comp-moment-remind-num">{{noticeList.length}}</span>
							<span class="comp-moment-remind-text">条消息</span>
						</div>
					</div>
					<div class="comp-moment-items">
						<div class="comp-moment-item" v-for="(moment,m_index) in momentList" :key="'chat-monent-item'+m_index">
							<div class="comp-moment-avater">
								<img :src="moment.senderPic | connectHost" alt="">
							</div>
							<div class="comp-moment-detail">
								<div class="comp-moment-name">
									<p>{{moment.senderName}}</p>
								</div>
								<div class="comp-moment-text" v-html="$options.filters.formatMsg(moment.content,'text')" v-if="moment.content !== ''">
								</div>
								<div class="comp-moment-extra">
									<div class="comp-moment-pics" v-if="moment.type == 1 && moment.pics.length > 0">
										<div class="comp-moment-pics-wrap" v-for="(pic,index) in moment.pics">
											<img :src="momentMediaIds[pic.mediaId]" alt="" @click="preview(moment.pics,'image',index)">
										</div>
									</div>
									<div class="comp-moment-video" v-else-if="moment.type == 2">
										<img :src="moment.video.videoPic" alt="">
										<span class="comp-moment-v-play" @click="preview(moment.video,'video',0)"></span>
									</div>
									<div class="comp-moment-link" v-else-if="moment.type == 3" @click="momentJump(moment.link.url)">
										<div class="comp-moment-l-avater">
											<img :src="momentMediaIds[moment.link.mediaId]" alt="">
										</div>
										<div class="comp-moment-l-text">
											<p>{{moment.link.linkText}}</p>
										</div>
									</div>
									<div class="comp-moment-music" v-else-if="moment.type == 4" @click="momentJump(moment.music.url)">
										<div class="comp-moment-m-avater">
											<img :src="momentMediaIds[moment.music.mediaId]" alt="">
											<span class="comp-moment-m-play"></span>
										</div>
										<div class="comp-moment-m-text">
											<p>{{moment.music.title}}</p>
											<p>{{moment.music.desc}}</p>
										</div>
									</div>
									<div class="comp-moment-m-finder" v-else-if="moment.type == 30">
										<div class="comp-moment-finder">
											<div class="comp-moment-finder-img">
												<img :src="moment.finder.thumbUrl" class="comp-moment-finder-thumb" />
												<img src="/img/video_play.png"  class="comp-moment-finder-play"/>
											</div>
											<div class="comp-moment-finder-info">
												<img :src="moment.finder.avatar"/>
												<p></p>
											</div>
											<div class="comp-moment-finder-desc">
												<p>{{moment.finder.nickname !== undefined ? moment.finder.nickname : '昵称为空'}}</p>
											</div>
											<div class="comp-moment-finder-tip">
												<img src="/img/finder.png"/>
												<p>视频号</p>
											</div>
										</div>
									</div>
									<div class="comp-moment-m-finder_live" v-else-if="moment.type == 31">
										<div class="comp-moment-finder">
											<div class="comp-moment-finder-img">
												<img :src="moment.finder_live.coverUrl" class="comp-moment-finder-thumb" />
												<img src="/img/video_play.png"  class="comp-moment-finder-play"/>
											</div>
											<div class="comp-moment-finder-info">
												<img :src="moment.finder_live.headUrl"/>
												<p>{{moment.finder_live.nickname !== undefined ? moment.finder_live.nickname : '昵称为空'}}</p>
											</div>
											<div class="comp-moment-finder-desc" v-if="moment.finder_live.desc1 !== undefined && moment.finder_live.desc1 !== 'null'">
												<p>{{moment.finder_live.desc1}}</p>
											</div>
											<div class="comp-moment-finder-tip">
												<img src="/img/finder.png"/>
												<p>视频号直播</p>
											</div>
										</div>
									</div>
								</div>
								<div class="comp-moment-time">
									<p>{{moment.sendTime | rechentDate}}</p>
								</div>
								<div class="comp-moment-i-tools">
									<div class="comp-moment-i-send">一键转发</div>
									<div class="comp-moment-i-other">
										<div class="comp-moment-i-item">
											<!-- <p><span class="comp-moment-i-reload"></span><i>更新</i></p> -->
											<p @click="replyComment(moment,m_index,1)"><span class="comp-moment-i-zan"></span><i>点赞</i></p>
											<p @click="showComment(m_index)"><span class="comp-moment-i-comment"></span><i>评论</i></p>
										</div>
									</div>
								</div>
								<div class="comp-moment-add-comment" v-if="moment.showAddComment">
									<div class="comp-moment-ac-input">
										<textarea v-model="addMoment" :placeholder="argued.argued_open_id !== '' ? '回复'+argued.argued_name+'：' : ''"></textarea>
									</div>
									<div class="comp-moment-ac-opts">
										<span class="comp-moment-ac-emoji" @click="showAddMEmoji(m_index)"></span>
										<span class="comp-moment-ac-send" @click="replyComment(moment,m_index,2)">评论</span>
									</div>
									<div class="comp-moment-ac-emoji-show" v-if="moment.showEmoji">
										<emoji @emoji-call="emojiCall($event,m_index)"></emoji>
									</div>
								</div>
								<div class="comp-moment-fc" v-if="moment.fabulous.length > 0 || moment.comments.length > 0">
									<div class="comp-moment-fabulous" v-if="moment.fabulous.length > 0">
										<span class="comp-moment-fabulous-icon"></span>
										<span v-for="(fabulou,key) in moment.fabulous">
											<i v-text="fabulou.dzName+'、'" v-if="key+1 < moment.fabulous.length"></i>
											<i v-text="fabulou.dzName" v-if="key+1 == moment.fabulous.length"></i>
										</span>
									</div>
									<div class="comp-moment-fc-line" v-if="moment.fabulous.length > 0 && moment.comments.length > 0"></div>
									<div class="comp-moment-comment" v-if="moment.comments.length > 0">
										<div class="comp-moment-c-item" v-for="(comment,c_index) in moment.comments">
											<div class="comp-moment-c-item-wrap" v-if="comment.commentToWxid === ''">
												<span class="comp-moment-c-name" @click="momentFansClick(m_index,c_index,comment.commentUserWxid)">{{comment.commentUser}}：</span>
												<span class="comp-moment-c-text"  v-html="$options.filters.formatMsg(comment.commentText,'text')"></span>
											</div>
											<div class="comp-moment-c-item-wrap" v-else>
												<span class="comp-moment-c-name" @click="momentFansClick(m_index,c_index,comment.commentUserWxid)">{{comment.commentUser}}</span>
												<span>回复</span>
												<span class="comp-moment-c-name">{{arguedFans[comment.commentToWxid]}}:</span>
												<span class="comp-moment-c-text" v-html="$options.filters.formatMsg(comment.commentText,'text')"></span>
											</div>
											<div class="comp-moment-c-opts" v-if="comment.showOpt">
												<ul>
													<li @click="goChatting(comment.commentUserWxid)" v-if="momentType == 2">聊天</li>
													<li @click="showComment(m_index,comment.commentId,comment.commentUserWxid,comment.commentUser,c_index)">评论</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="comp-moment-loadding" v-if="!canRefresh">
						<img src="/img/loading.gif" alt="" v-if="!isEnd">
						<span v-if="!isEnd">朋友圈加载中，请稍后...</span>
						<span v-if="isEnd" class="comp-moment-loadding-no">暂无更多朋友圈</span>
					</div>
				</div>
			</div>
		</div>
		<div class="comp-moment-news" v-else-if="viewType == 'msg' && momentType == 2">
			<chat-moment-msg @chat-m-msg-back="chatMMsgBack($event)" :msgList="noticeList"></chat-moment-msg>
		</div>
		<div class="comp-moment-news" v-else-if="viewType == 'info' && momentType == 2">
			<chat-moment-info @chat-m-msg-back="chatMMsgBack($event)" :moments="replyDetail"></chat-moment-info>
		</div>
	</div>
</template>

<script>
	import {pushCustomSns,pushMomentsReply,pushFansSns} from '../socket/socketEventSender.js'
	import {webGetCustomById,webUpdateCustomByWxId} from '../network/web/custom.js'
	import {webGetCustomFansExtendById,webSaveCustomFansExtendById} from '../network/web/custom-friends-extend.js'
	import {webMomentsReplySave,webGetMomentReplyNoReadList,webMomentsAllRead} from '../network/web/moments.js'
	import Emoji from './Emoji.vue'
	import {getFansListByCustomIdAndWxids,getFansByCustomIdAndWxid} from '../network/local/friend.js'
	import ChatMomentMsg from './ChatMomentMsg.vue'
	import ChatMomentInfo from './ChatMomentInfo.vue'
	
	export default {
		name:'ChatMoment',
		components:{
			Emoji,
			ChatMomentMsg,
			ChatMomentInfo
		},
		props:{
			// 查看的朋友圈类型:1,查看粉丝的，2，查看客服朋友圈
			momentType:{
				type: Number,
				default: 1
			},
			no_read:{
				type: Number,
				default: 1
			},
			custom:{
				type:Object,
				default:function(){
					return {}
				}
			},
			friend:{
				type:Object,
				default:function(){
					return {}
				}
			}
		},
		data(){
			return {
				canRefresh: true,
				isEnd: false,
				lastSnsId:0,
				momentMediaIds:{},
				momentList:[],
				addMoment: '',
				argued:{
					commentId:'0',
					argued_open_id: '',
					argued_name: ''
				},
				arguedFans:{},
				needFindArguedFans:[],
				scrollTop: 0,
				viewType: 'basic',
				noticeList:[],
				lastNoticeUser:{},
				replyDetail:{}
			}
		},
		computed:{
			// 监听vuex中的其他事件
			momentData(){
				return this.$store.state.otherEvent
			},
			
			// 监听vuex中的评论列表
			mReplyList(){
				return this.$store.state.mReply
			}
		},
		
		methods:{
			// 初始化基本数据
			init(){
				this.canRefresh = true
				this.isEnd = false
				this.lastSnsId = 0
				this.momentList = []
				this.momentMediaIds = {}
				this.arguedFans = {}
				this.needFindArguedFans = []
				this.scrollTop = 0
				this.viewType = 'basic'
				/* this.noticeList = []
				this.lastNoticeUser = {} */
				this.replyDetail = {}
			},
			// 初始化评论和点赞数据
			initComment(){
				this.argued =  {
					commentId: '0',
					argued_open_id: '',
					argued_name: ''
				}
				this.addMoment = ""
			},
			// 处理朋友圈数据-客服朋友圈-基本数据
			handleMomentData(data){
				// 判断是否为刷新加粉，如果是刷新加粉并且返回为空，则重新拉一次数据
				if(data.sns === undefined || data.sns.length === 0){
					if(data.snsId !== undefined && data.snsId == 0){
						webGetCustomById(this.custom.id,customData=>{
							if(customData.code == 1 && customData.data.snsId != null && customData.data.snsId != "" && customData.data.snsId != 0){
								pushCustomSns(this.custom.phone_id,customData.data.snsId)
								this.isEnd = false
							}else{
								this.isEnd = true
								return
							}
						})
					}else{
						this.isEnd = true
						return
					}
				}
				// 否则渲染数据
				else{
					let c_wxid = data.fromUsername === undefined ? '' : data.fromUsername
					if(c_wxid === '' || c_wxid !== this.custom.open_id){
						return
					}
					let sns = data.sns
					let firstSnsId = sns[0].snsId
					this.lastSnsId = sns[sns.length-1].snsId
					// 如果是拉取最新的，则保存最新的snsId
					if(data.snsId !== undefined && data.snsId == 0){
						let customData = {
							wxid: c_wxid,
							snsId: firstSnsId
						}
						webUpdateCustomByWxId(customData,res=>{
							this.drawMomentData(sns)
						})
						return
					}
					this.drawMomentData(sns)
				}
			},
			
			// 处理朋友圈数据-粉丝朋友圈-基本数据
			handleFansMomentData(data){
				// 判断是否为刷新加粉，如果是刷新加粉并且返回为空，则重新拉一次数据
				if(data.sns === undefined || data.sns.length === 0){
					if(data.snsId !== undefined && data.snsId == 0){
						webGetCustomFansExtendById(this.friend.fans_id,friendData=>{
							if(friendData.code == 1 && friendData.data.sns_id != null && friendData.data.sns_id != "" && friendData.data.sns_id != 0){
								pushFansSns(this.friend.phone_id,this.friend.fans_wx_id,friendData.data.sns_id)
								this.isEnd = false
							}else{
								this.isEnd = true
								return
							}
						})
					}else{
						this.isEnd = true
						return
					}
				}
				// 否则渲染数据
				else{
					let wxid = data.wxid === undefined ? '' : data.wxid
					if(wxid === '' || wxid !== this.friend.fans_wx_id){
						return
					}
					let sns = data.sns
					let firstSnsId = sns[0].snsId
					this.lastSnsId = sns[sns.length-1].snsId
					// 如果是拉取最新的，则保存最新的snsId
					if(data.snsId !== undefined && data.snsId == 0){
						webSaveCustomFansExtendById(this.friend.fans_id,firstSnsId,res=>{
							this.drawMomentData(sns)
						})
						return
					}
					this.drawMomentData(sns)
				}
			},
			
			// 处理朋友圈数据-根据数据，渲染不同类型的朋友圈
			drawMomentData(data){
				this.needFindArguedFans = []
				for (let i = 0; i < data.length; i++) {
					let sns  = data[i]
					if(sns.snsType === undefined){
						continue
					}
					switch(parseInt(sns.snsType)){
						// 普通朋友圈-有图片
						case 1:
							this.drawBasicMomentData(sns,1)
							break
						// 普通朋友圈-无图片
						case 2:
							this.drawBasicMomentData(sns,1)
							break
						// 链接朋友圈
						case 3:
							this.drawBasicMomentData(sns,3)
							break
						// 音乐朋友圈
						case 4:
							this.drawBasicMomentData(sns,4)
							break
						// 视频朋友圈
						case 15:
							this.drawBasicMomentData(sns,2)
							break
						// 视频号朋友圈
						case 28:
							this.drawBasicMomentData(sns,30)
							break
						// 视频号直播朋友圈
						case 34:
							this.drawBasicMomentData(sns,31)
							break
					}
				}
				this.$nextTick(function(){
					this.canRefresh = true
				})
				// 异步获取评论中的粉丝昵称
				if(this.needFindArguedFans.length > 0){
					getFansListByCustomIdAndWxids(this.custom.id,this.needFindArguedFans,fansList=>{
						this.needFindArguedFans = []
						for (let i = 0; i < fansList.length; i++) {
							if(this.arguedFans[fansList[i].open_id] === undefined || this.arguedFans[fansList[i].open_id] === ''){
								this.$set(this.arguedFans,fansList[i].open_id,fansList[i].wx_name)
							}
						}
					})
				}
			},
			
			
			// 处理朋友圈数据-根据数据，渲染朋友圈-处理基本数据-单个数据
			drawBasicMomentData(data,type){
				let pics = []
				let video = {
					videoPic: '',
					videoUrl: ''
				}
				let link = {
					mediaId:'',
					linkText:'',
					url: ''
				}
				let music = {
					mediaId:'',
					title:'',
					desc:'',
					url: ''
				}
				let finder = {}
				let finder_live = {}
				let content = data.contentText
				// 处理评论
				let comments = []
				if(data.comments !== undefined && data.comments.length > 0){
					for (let i = 0; i < data.comments.length; i++) {
						// 查找被回复的粉丝信息
						let commentToWxid = data.comments[i].commentToId
						let commentToUser = ''
						if(commentToWxid === undefined || commentToWxid === null || commentToWxid === '' || commentToWxid === 'null'){
							commentToWxid = ''
						}else{
							if(commentToWxid === this.custom.open_id){
								commentToUser = this.custom.wx_name
							}else{
								if(this.needFindArguedFans.indexOf(commentToWxid) === -1){
									this.needFindArguedFans.push(commentToWxid)
								}
							}
						}
						comments.push({
							commentId: data.comments[i].commentId,
							commentUser: data.comments[i].commentName,
							commentUserWxid: data.comments[i].commentFromId,
							commentText: data.comments[i].commentContent,
							commentToWxid: commentToWxid,
							commentToUser: commentToUser,
							showOpt: false
						})
						if(commentToWxid !== ''){
							if(this.arguedFans[commentToWxid] === undefined){
								this.$set(this.arguedFans,commentToWxid,commentToUser)
							}
						}
					}
				}
				// 处理点赞
				let fabulous = []
				if(data.dianzan !== undefined && data.dianzan.length > 0){
					for (let i = 0; i < data.dianzan.length; i++) {
						fabulous.push({
							dzName: data.dianzan[i].dzName,
							dzWxid: data.dianzan[i].dzWxid
						})
					}
				}
				// infoJsonArray数据处理，主要为图片
				if(data.infoJsonArray !== undefined && data.infoJsonArray.length > 0){
					if(type == 1){
						for (let i = 0; i < data.infoJsonArray.length; i++) {
							pics.push({
								bpToken: data.infoJsonArray[i].bpToken,
								bpUrl: data.infoJsonArray[i].bpUrl,
								mediaId: data.infoJsonArray[i].mediaId,
								stToken: data.infoJsonArray[i].stToken,
								stUrl: data.infoJsonArray[i].stUrl
							})
							if( data.infoJsonArray[i].mediaId !== undefined && this.momentMediaIds[data.infoJsonArray[i].mediaId] === undefined){
								this.$set(this.momentMediaIds,data.infoJsonArray[i].mediaId,data.infoJsonArray[i].stUrl)
							}
						}
					}else if(type == 2){
						video = {
							videoPic: data.infoJsonArray[0].stUrl,
							videoUrl: data.infoJsonArray[0].bpUrl
						}
					}else if(type == 3){
						link = {
							linkText:data.infoJsonArray[0].BTitle,
							mediaId: data.infoJsonArray[0].mediaId,
							url: data.infoJsonArray[0].url
						}
						if(link.mediaId !==undefined && this.momentMediaIds[link.mediaId] === undefined){
							this.$set(this.momentMediaIds,link.mediaId,data.infoJsonArray[0].stUrl)
						}
					}else if(type == 4){
						music = {
							mediaId: data.infoJsonArray[0].mediaId,
							title: data.infoJsonArray[0].title,
							desc: data.infoJsonArray[0].desc,
							url: data.infoJsonArray[0].url
						}
						if(music.mediaId !==undefined && this.momentMediaIds[music.mediaId] === undefined){
							this.$set(this.momentMediaIds,music.mediaId,data.infoJsonArray[0].stUrl)
						}
					}
				}else{
					if(type == 30){
						try{
							finder = JSON.parse(data.finder)
						}catch(e){
							//TODO handle the exception
							console.log("视频号朋友圈解析异常")
						}
					}else if(type == 31){
						try{
							finder_live = JSON.parse(data.finder)
						}catch(e){
							//TODO handle the exception
							console.log("视频号直播朋友圈解析异常")
						}
					}
				}
				
				// 全部数据
				this.momentList.push({
					senderName:data.nickname,
					senderPic: data.userPic,
					wxid:data.wxid, // 发圈人的微信id
					type: type,
					content:content,
					pics:pics,
					video:video,
					link: link,
					music:music,
					finder: finder,
					finder_live: finder_live,
					sendTime:data.snsTimer,
					fabulous:fabulous,
					comments:comments,
					snsId:data.snsId,
					showEmoji: false,
					showAddComment: false
				})
			},
			
			// 更新媒体库
			updateMediaIds(data){
				if(data.files !== undefined){	
					this.$set(this.momentMediaIds,data.files.mediaId,data.files.filePath+"?x-oss-process=image/auto-orient,1/resize,m_fill,w_150,h_150/quality,q_90")
				}
			},
			
			// 滚动刷新数据
			momentScroll(event){
				let page = document.getElementById("comp-moment-box-wrap")
				this.scrollTop = page.scrollTop
				if(page.scrollTop+page.clientHeight >= page.scrollHeight-25 && this.canRefresh &&
				 ((this.custom.id !== undefined && this.custom.id > 0) || (this.friend.fans_id !== undefined && this.friend.fans_id > 0))){
					this.canRefresh = false
					if(this.momentType == 2){
						pushCustomSns(this.custom.phone_id,this.lastSnsId)
					}else if(this.momentType == 1){
						pushFansSns(this.friend.phone_id,this.friend.fans_wx_id,this.lastSnsId)
					}
				}
			},
			
			// 朋友圈跳转
			momentJump(url){
				window.open(url)
			},
			
			// 图片或视频预览点击处理
			preview(content,type,index){
				if(type === 'image'){
					if(!content instanceof Array){
						return
					}
					let imgList = []
					for (var i = 0; i < content.length; i++) {
						if(this.momentMediaIds[content[i].mediaId] !== undefined){
							imgList.push(this.momentMediaIds[content[i].mediaId])
						}
					}
					if(imgList.length === 0){
						return
					}
					this.$store.commit('updatePreviewFile',{
						 type:'image',
						 data:imgList,
						 index: parseInt(index)
					})
				}else if(type === 'video'){
					let videoData = {
						url: content.videoUrl,
						thumbUrl: content.videoPic
					}
					this.$store.commit('updatePreviewFile',{
						 type:'video',
						 data:videoData,
						 index: parseInt(index)
					})
				}
			},
			
			// 评论中粉丝昵称点击处理
			momentFansClick(momentIndex,commentIndex,userWxid){
				if(userWxid == this.custom.open_id || userWxid == this.friend.custom_wx_id){
					return
				}
				for (let i = 0; i < this.momentList[momentIndex].comments.length; i++) {
					if(i !== commentIndex){
						this.momentList[momentIndex].comments[i].showOpt = false
					}
				}
				this.momentList[momentIndex].comments[commentIndex].showOpt = !this.momentList[momentIndex].comments[commentIndex].showOpt
			},
			
			/**
			 * 评论按钮点击-展示和隐藏评论页面
			 * @param {Object} index 朋友圈的数组索引
			 * @param {Object} commentId 评论id
			 * @param {Object} argued_open_id 准备回复的粉丝wxid
			 * @param {Object} argued_name 准备回复的粉丝昵称
			 * @param {Object} c_index 当前朋友圈的评论索引值
			 */
			showComment(index,commentId,argued_open_id,argued_name,c_index){
				if(c_index !== undefined){
					this.momentList[index].comments[c_index].showOpt = false
				}
				if(commentId !== undefined && commentId != '0'){
					if(argued_open_id === this.custom.open_id || argued_open_id === this.friend.custom_wx_id){
						return
					}
					if(argued_open_id == this.argued.argued_open_id){
						this.momentList[index].showAddComment = !this.momentList[index].showAddComment
					}else{
						this.argued.argued_open_id = argued_open_id
						this.argued.argued_name = argued_name
						this.argued.commentId = commentId
						this.momentList[index].showAddComment = true
					}
				}else{
					this.argued.argued_open_id = ''
					this.argued.argued_name = ''
					this.argued.commentId = '0'
					this.momentList[index].showAddComment = !this.momentList[index].showAddComment
				}
			},
			
			// 评论页面-表情点击-表情页面的显示和隐藏
			showAddMEmoji(index){
				this.momentList[index].showEmoji = !this.momentList[index].showEmoji
			},
			
			// 表情点击回调
			emojiCall(data,index){
				this.addMoment += '['+data.title+']'
				this.momentList[index].showEmoji = false
			},
			
			// 发表评论/点赞
			replyComment(moment,index,snsType){
				if(this.addMoment === "" && snsType === 2){
					CHAT_LAYER.msg("评论内容不能为空",{icon:2})
					return
				}
				if(moment.snsId === undefined || moment.snsId === ""){
					CHAT_LAYER.msg("snsId为空",{icon:2})
					return
				}
				let content = this.addMoment
				let account_comment_id = '0'
				let argued_open_id = ''
				let argued_name = ''
				if(snsType == 1){
					content = ''
					// 判断是否点赞过
					let fabulous =  this.momentList[index].fabulous
					if(fabulous.length > 0){
						for (let i = 0; i < fabulous.length; i++) {
							if(fabulous[i].dzWxid === this.custom.open_id || fabulous[i].dzWxid === this.friend.custom_wx_id){
								CHAT_LAYER.msg("不能重复点赞",{icon:2})
								return
							}
						}
					}
				}else if(snsType == 2){
					argued_open_id = this.argued.argued_open_id
					argued_name = this.argued.argued_name
					account_comment_id = this.argued.commentId
				}
				let data = {
					account_open_id: this.custom.open_id !== undefined ? this.custom.open_id : this.friend.custom_wx_id,
					account_name: this.custom.wx_name !== undefined ?  this.custom.wx_name : this.friend.custom_wx_name,
					friend_open_id: moment.wxid,
					friend_name: moment.senderName,
					account_sns_id: moment.snsId,
					content: content,
					account_comment_id: account_comment_id,
					argued_open_id: argued_open_id,
					argued_name: argued_name,
					moment: JSON.stringify(moment)
				}
				webMomentsReplySave(data,(res)=>{
					if(res){
						if(snsType == 2){
							// 界面评论显示
							this.momentList[index].comments.push({
								commentId: 0,
								commentUser: data.account_name,
								commentUserWxid: data.account_open_id,
								commentText: data.content,
								commentToWxid: data.argued_open_id,
								commentToUser: data.argued_name
							})
							this.addMoment = ""
							this.momentList[index].showAddComment = false
							if(this.arguedFans[data.argued_open_id] === undefined || this.arguedFans[data.argued_open_id] === ''){
								this.$set(this.arguedFans,data.argued_open_id,data.argued_name)
							}
						}else if(snsType == 1){
							this.momentList[index].fabulous.push({
								dzName: data.account_name,
								dzWxid: data.account_open_id
							})
						}
						// 推送socket事件
						let phone_id = this.custom.phone_id !== undefined ? this.custom.phone_id : this.friend.phone_id
						pushMomentsReply(phone_id,snsType,data)
					}
				})
			},
			
			// 跳转聊天页面
			goChatting(wxid){
				let query = {
					c_id: this.custom.id,
					c_wxid: this.custom.open_id,
					f_wxid: wxid,
					type: 'fans'
				}
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			},
			
			// 刷新客服朋友圈
			refresh(custom){
				if(this.momentType != 2){
					return
				}
				this.init()
				this.initComment()
				this.canRefresh = false
				let phone_id = ''
				if(custom === undefined){
					phone_id = this.custom.phone_id
				}else{
					phone_id = custom.phone_id
				}
				if(phone_id === undefined){
					return
				}
				pushCustomSns(phone_id,this.lastSnsId)
			},
			
			// 刷新粉丝朋友圈
			refreshFansMoment(friend){
				if(this.momentType != 1){
					return
				}
				this.init()
				this.initComment()
				this.canRefresh = false
				let phone_id = ''
				let wxid = ''
				if(friend === undefined){
					phone_id = this.friend.phone_id
					wxid = this.friend.fans_wx_id
				}else{
					phone_id = friend.phone_id
					wxid = friend.fans_wx_id
				}
				if(phone_id === undefined || phone_id === '' || wxid === undefined || wxid === ''){
					return
				}
				pushFansSns(phone_id,wxid,this.lastSnsId)
			},
			
			// 处理朋友圈评论回调-包括客服主动评论的/粉丝被动评论的
			handleFansReplyComment(data){
				if(data.length > 0){
					let lastReply = data[data.length-1]
					// 添加新的点赞
					if(lastReply.fabulous.dzName !== undefined){
						for (let i = 0; i < this.momentList.length; i++) {
							if(this.momentList[i].snsId === lastReply.SnsId){
								this.momentList[i].fabulous.push(lastReply.fabulous)
								break
							}
						}
					}
					// 添加新的评论
					if(lastReply.comment.commentId !== undefined){
						for (let i = 0; i < this.momentList.length; i++) {
							if(this.momentList[i].snsId === lastReply.SnsId){
								this.momentList[i].comments.push(lastReply.comment)
								break
							}
						}
					}
					// 修改最后评论/点赞的人的信息
					this.lastNoticeUser = lastReply.fans
					this.noticeList = data
				}else{
					this.noticeList = []
					this.lastNoticeUser = {}
				}
			},
			
			// 通知列表点击
			noticeClick(){
				this.viewType = 'msg'
			},
			
			// 内嵌页面点击回调
			chatMMsgBack(val){
				if(val.type !== undefined){
					if(val.type === 'info' && val.data !== undefined){
						let data = val.data
						data.customId = val.customId !== undefined ? val.customId : ''
						this.replyDetail = data
					}else if(val.type === 'basic'){
						this.noticeList = []
						this.lastNoticeUser = {}
						webMomentsAllRead((res)=>{
							// nothing to do
						})
						this.$store.commit('updateMReply',{
							type: 'clear',
							data: []
						})
					}
					this.viewType = val.type
				}else{
					this.viewType = val
				}
			},
			
			// 页面查看未读点击
			get_read(){
				let _this = this
				webGetMomentReplyNoReadList(data=>{
					if(data === false){
						this.noticeList = []
					}else{
						if(data.length > 0){
							this.noticeList = data
							this.lastNoticeUser = data[data.length - 1]['fans']
						}
					}
				})
			}
		},
		
		created() {
			// 创建时，如果时粉丝朋友圈，则拉取最新的
			if(this.momentType == 1){
				this.refreshFansMoment()
			}
			
			// 渲染朋友圈评论列表
			this.handleFansReplyComment(JSON.parse(JSON.stringify(this.mReplyList)))
		},
		
		watch:{
			// 监听客服切换-当查看客服朋友圈时生效
			custom(nVal,oVal){
				if(nVal.id !== undefined && nVal.id > 0 && nVal.id !== oVal.id){
					this.refresh(nVal)
				}
			},
			
			// 监听粉丝变化-当查看粉丝朋友圈时生效
			friend(nVal,oVal){
				if(nVal.fans_id !== undefined && nVal.fans_id > 0 && nVal.fans_id !== oVal.fans_id){
					this.refreshFansMoment(nVal)
				}
			},
			
			// 监听全局事件数据变化-只针对朋友圈和朋友圈图片
			momentData(nVal){
				if(nVal.type === undefined){
					return
				}
				switch(nVal.type){
					// 客服朋友圈
					case "mySns":
						this.handleMomentData(nVal)
						break
					// 客服朋友圈图片信息
					case "image_post_refresh":
						this.updateMediaIds(nVal)
						break
					// 粉丝朋友圈
					case "fansSns":
						this.handleFansMomentData(nVal)
						break
					// 粉丝朋友圈图片信息
					case "image_fans_post_refresh":
						this.updateMediaIds(nVal)
						break
				}
			},
			
			// 监听vuex中的评论列表
			mReplyList(nVal){
				this.handleFansReplyComment(JSON.parse(JSON.stringify(nVal)))
			},
			
			// 监听未读点击
			no_read(nVal,oVal){
				if(nVal != 1){
					this.get_read()
				}
			}
		},
		activated() {
			let page = document.getElementById("comp-moment-box-wrap")
			if(page !== null){
				page.scrollTop = this.scrollTop
			}
		}
	}
</script>

<style>
	.comp-moment{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.comp-moment .comp-moment-wrap,.comp-moment .comp-moment-news{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.comp-moment-wrap .comp-moment-tools{
		width: 100%;
		height: 30px;
		line-height: 30px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
		box-shadow: 0 0 3px 0 #717488a6;
	}
	.comp-moment-wrap .comp-moment-tools span{
		display: block;
		width: 18px;
		height: 18px;
		margin: 0 5px;
		background-position: center;
		background-size: 20px 20px;
		background-repeat: no-repeat;
		cursor: pointer;
		border: 1px solid #CCCCCC;
		border-radius: 10px;
	}
	.comp-moment-t-title{
		font-weight: bold;
		color: #42B983;
	}
	.comp-moment-t-reload{
		background-image: url(../assets/img/comp-reload.png);
	}
	.comp-moment-t-eye{
		background-image: url(../assets/img/comp-eye.png);
		background-size: 15px 15px !important;
	}
	.comp-moment-t-close{
		background-image: url(../assets/img/comp-close.png);
		background-size: 15px 15px !important;
	}
	.comp-moment-wrap .comp-moment-box{
		position: absolute;
		top: 30px;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
	.comp-moment-wrap .comp-moment-me-box{
		top: 0 !important;
	}
	.comp-moment-box .comp-moment-box-wrap{
		width: 100%;
		height: 100%;
		position: relative;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.comp-moment-box-wrap .comp-moment-remind{
		height: 36px;
		padding: 10px 0;
		overflow: hidden;
		border-bottom: 1px solid #ececec;
	}
	.comp-moment-remind .comp-moment-remind-box{
		margin: 0 auto;
		width: 120px;
		height: 24px;
		padding: 6px 10px;
		background-color: #374b69;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #FFFFFF;
		cursor: pointer;
	}
	.comp-moment-remind-box > *{
		display: block;
	}
	.comp-moment-remind-box img{
		width: 24px;
		height: 24px;
	}
	.comp-moment-remind-box .comp-moment-remind-num{
		padding: 0 5px;
		background-color: #ff4d00;
		margin: 0 5px 0 15px;
		height: 18px;
		line-height: 18px;
	}
	.comp-moment-remind-box .comp-moment-remind-text{
		height: 18px;
		line-height: 18px;
	}
	.comp-moment-box-wrap .comp-moment-items{
		width: 100%;
		height: auto;
		color: #666666;
	}
	.comp-moment-items .comp-moment-item{
		width: 100%;
		height: auto;
		min-height: 100px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		border-bottom: 1px solid #ececec;
		padding: 10px;
		box-sizing: border-box;
	}
	.comp-moment-items .comp-moment-item:last-child{
		border-bottom:none;
	}
	.comp-moment-item .comp-moment-avater{
		width: 44px;
		height: 44px;
		margin-right: 6px;
	}
	.comp-moment-avater img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.comp-moment-item .comp-moment-detail{
		width: 0;
		flex-grow: 1;
	}
	.comp-moment-detail .comp-moment-name{
		height: 24px;
		line-height: 24px;
		font-weight: bold;
		color: #225f8c;
	}
	.comp-moment-detail .comp-moment-text{
		padding: 5px 0;
		line-height: 20px;
	}
	.comp-moment-detail .comp-moment-extra{
		width: 100%;
		height: auto;
		overflow: hidden;
	}
	.comp-moment-extra .comp-moment-pics{
		width: 100%;
		max-width: 400px;
		padding: 5px 0;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.comp-moment-pics .comp-moment-pics-wrap{
		width: 32%;
		position: relative;
		height: 0;
		padding-bottom: 32%;
		margin: 1px;
	}
	.comp-moment-pics-wrap img{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		box-shadow: 0 0 1px 0 #5d5d5d;
	}
	.comp-moment-extra .comp-moment-video{
		width: 80%;
		max-width: 200px;
		height: auto;
		position: relative;
		padding: 5px 0;
	}
	.comp-moment-video img{
		width: 100%;
		height: auto;
		min-height: 80px;
		background-color: #3e3e3e;
	}
	.comp-moment-video .comp-moment-v-play{
		width: 30px;
		height: 30px;
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		background-image: url(../../public/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		cursor: pointer;
	}
	.comp-moment-extra .comp-moment-link{
		width: 100%;
		height: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		overflow: hidden;
		background-color: #EEEEEE;
		padding: 5px;
		box-sizing: border-box;
		cursor: pointer;
		font-size: 12px;
	}
	.comp-moment-link .comp-moment-l-avater{
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 5px;
	}
	.comp-moment-l-avater img{
		width: 100%;
		height: 100%;
		border-radius: 2px;
		background-color: #3e3e3e;
	}
	.comp-moment-link .comp-moment-l-text{
		width: 0;
		flex-grow: 1;
		height: 40px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.comp-moment-l-text p{
		display: block;
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
	}
	.comp-moment-extra .comp-moment-music{
		width: 100%;
		height: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		overflow: hidden;
		background-color: #EEEEEE;
		padding: 5px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.comp-moment-music .comp-moment-m-avater{
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 5px;
		position: relative;
	}
	.comp-moment-m-avater img{
		width: 100%;
		height: 100%;
		border-radius: 2px;
		background-color: #3e3e3e;
	}
	.comp-moment-m-avater .comp-moment-m-play{
		width: 20px;
		height: 20px;
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		background-image: url(../../public/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.comp-moment-music .comp-moment-m-text{
		width: 0;
		flex-grow: 1;
		height: 40px;
		overflow: hidden;
	}
	.comp-moment-m-text p{
		display: block;
		width: 100%;
		line-height: 20px;
		height: 20px;
		overflow: hidden;
		font-size: 12px;
	}
	.comp-moment-m-text p:first-child{
		font-size: 13px;
		color: #225f8c;
	}
	.comp-moment-detail .comp-moment-time{
		height: 24px;
		line-height: 24px;
		color: #8f8f8f;
	}
	.comp-moment-detail .comp-moment-i-tools{
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 13px;
	}
	.comp-moment-i-tools .comp-moment-i-send{
		width: 60px;
		cursor: pointer;
	}
	.comp-moment-i-tools .comp-moment-i-other{
		width: 0;
		flex-grow: 1;
	}
	.comp-moment-i-other .comp-moment-i-item{
		display: flex;
		justify-content: flex-end;
		flex-wrap: nowrap;
		width: 100%;
		height: 30px;
		line-height: 30px;
	}
	.comp-moment-i-item p{
		display: block;
		padding-left: 8px;
		cursor: pointer;
	}
	.comp-moment-i-item p span{
		width: 14px;
		height: 14px;
		display: inline-block;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 14px auto;
		vertical-align: middle;
		margin-right: 2px;
	}
	.comp-moment-i-item .comp-moment-i-reload{
		background-image: url(../assets/img/comp-m-reload.png);
	}
	.comp-moment-i-item .comp-moment-i-zan{
		background-image: url(../assets/img/comp-m-zan.png);
	}
	.comp-moment-i-item .comp-moment-i-comment{
		background-image: url(../assets/img/comp-m-comment.png);
	}
	.comp-moment-i-item p i{
		display: inline-block;
		vertical-align: middle;
		font-style: unset;
	}
	.comp-moment-detail .comp-moment-add-comment{
		margin: 5px 0;
		position: relative;
	}
	.comp-moment-add-comment .comp-moment-ac-input{
		height: 50px;
		overflow: hidden;
	}
	.comp-moment-ac-input textarea{
		height: 50px;
		width: 100%;
		border: 1px solid #e3e3e3;
		padding: 5px;
		box-sizing: border-box;
		line-height: 18px;
		resize: none;
		border-radius: 4px;
		color: #888888;
	}
	.comp-moment-ac-input textarea:focus{
		border: 1px solid #009688;
	}
	.comp-moment-add-comment .comp-moment-ac-opts{
		width: 100%;
		margin-top: 5px;
		height: 22px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.comp-moment-ac-opts span{
		display: block;
		user-select: none;
		height: 22px;
		line-height: 22px;
		cursor: pointer;
	}
	.comp-moment-ac-opts .comp-moment-ac-emoji{
		width: 22px;
		background-image: url(../assets/img/comp-c-tools-emoji.png);
		background-position: center;
		background-size: 22px auto;
	}
	.comp-moment-ac-opts .comp-moment-ac-send{
		background-color: #1178b5;
		padding: 0 5px;
		color: #FFFFFF;
	}
	.comp-moment-add-comment .comp-moment-ac-emoji-show{
		position: absolute;
		width: 405px;
		height: 200px;
		max-width: 100%;
		bottom: 32px;
		left: -5px;
	}
	.comp-moment-detail .comp-moment-fc{
		background-color: #EEEEEE;
		padding: 5px;
		position: relative;
		margin-top: 5px;
		border-radius: 2px;
	}
	.comp-moment-fc::after{
		display: block;
		content: '';
		width: 10px;
		height: 10px;
		background-color: #EEEEEE;
		position: absolute;
		top: -4px;
		left: 12px;
		transform: rotateZ(45deg);
	}
	.comp-moment-fc-line{
		margin: 5px 0;
		height: 1px;
		background-color: #ffffff;
	}
	.comp-moment-detail .comp-moment-fabulous{
		width: 100%;
		line-height: 20px;
		font-size: 12px;
	}
	.comp-moment-fabulous span{
		display: inline-block;
		cursor: pointer;
	}
	.comp-moment-fabulous .comp-moment-fabulous-icon{
		width: 16px;
		height: 16px;
		background-image: url(../assets/img/comp-m-zan.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		vertical-align: text-bottom;
		margin-right: 5px;
	}
	.comp-moment-fabulous i{
		font-style: normal;
	}
	.comp-moment-detail .comp-moment-comment{
		width: 100%;
		font-size: 12px;
	}
	.comp-moment-comment .comp-moment-c-item{
		padding: 2px 0;
		line-height: 18px;
		position: relative;
	}
	.comp-moment-c-item .comp-moment-c-name{
		font-weight: 600;
		color: #225f8c;
		cursor: pointer;
	}
	.comp-moment-c-item .comp-moment-c-text{
		color: #999999;
	}
	.comp-moment-c-item .comp-moment-c-opts{
		position: absolute;
		width: 100px;
		height: auto;
		top: -66px;
		left: 0;
		background-color: #212121;
		z-index: 1;
		padding: 5px 5px;
		line-height: 26px;
		color: #FFFFFF;
		border-radius: 2px;
		text-indent: 5px;
	}
	.comp-moment-c-item .comp-moment-c-opts::after{
		display: block;
		content: '';
		position: absolute;
		bottom: -5px;
		left: 10px;
		width: 10px;
		height: 10px;
		background-color: #212121;
		transform: rotateZ(45deg);
	}
	.comp-moment-c-opts li{
		cursor: pointer;
	}
	.comp-moment-c-opts li:hover{
		background-color: #414141; 
	}
	.comp-moment-c-text>img{
		height: 20px !important;
		width: auto !important;
	}
	.comp-moment-loadding{
		padding: 5px 0;
		text-align: center;
		color: #42B983 ;
	}
	.comp-moment-loadding>*{
		display: inline-block;
		vertical-align: middle;
	}
	.comp-moment-loadding img{
		margin-right: 5px;
	}
	.comp-moment-loadding-no{
		color: #999999 !important;
	}
	.circle-menu>.comp-chat-custom>.comp-chat-custom-all{
		display: none;
	}
	.circle-menu>.comp-chat-custom>.comp-chat-custom-list{
		top: 0;
	}
	/* 视频号消息样式 */
	.comp-moment-finder{
		width: 220px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		border: 1px solid #CCCCCC;
		border-radius: 2px;
	}
	.comp-moment-finder-img{
		width: 100%;
		height: auto;
		position: relative;
	}
	.comp-moment-finder-img > .comp-moment-finder-thumb{
		width: 100%;
		height: auto;
	}
	.comp-moment-finder-img .comp-moment-finder-play{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 40px;
		height: 40px;
	}
	.comp-moment-finder-info{
		height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
	}
	.comp-moment-finder-info > img{
		width: 22px;
		height: 22px;
		display: block;
		margin: 0 5px;
		border-radius: 11px;
	}
	.comp-moment-finder-desc{
		padding: 0 5px;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
	}
	.comp-moment-finder-desc p{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.comp-moment-finder-tip{
		border-top: 1px solid #EEEEEE;
		margin-top: 5px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
	}
	.comp-moment-finder-tip > img{
		width: 18px;
		height: 18px;
		display: block;
		margin: 0 5px;
	}
</style>
